import { useEffect, useState } from "react";
import axios from "axios";
// import CustomTable from "../../components/customTable/CustomTable";
import CustomTableForDsr from "../../components/customTable/CustomTableForDsr";
import { createMRTColumnHelper } from "material-react-table";
import {
  Box,
  IconButton,
  Tooltip,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material";

import dayjs from "dayjs";
import axiosInstanceMainUrl from "../../utils/axiosInstanceMainUrl";
// import CSVtoXLSX from "./CSVtoXLSX";

export default function Dsr() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"));
  // console.log("startDate: ", dayjs(startDate).format("DD-MM-YYYY"));
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const mainUrl = import.meta.env.VITE_MAIN_URL;
  // console.log("mainUrl: ", mainUrl);
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  // ✅ Helper function to calculate previous & next values based on date difference
  const getPrevNext = (selectedDate) => {
    const today = dayjs().startOf("day");
    const selected = dayjs(selectedDate).startOf("day");
    const diff = today.diff(selected, "day");
    // e.g., if today → diff = 0 → prev=0,next=0; tomorrow → diff=-1; yesterday → diff=1
    return { previous: diff, next: diff };
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { previous, next } = getPrevNext(startDate);
        const url = `/api/admin/drsrecon?previous=${previous}&next=${next}`;
        // const url = `/DSR?previous=${previous}&next=${next}`;
        // const url = `${mainUrl}/DSR?previous=${previous}&next=${next}`;
        const response = await axiosInstanceMainUrl.get(url);
        setData(response.data?.data || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    if (startDate) fetchData();
  }, [startDate]);

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.userName || "N/A"}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("orderAmount", { header: "Order Amount" }),
    columnHelper.accessor("amount", { header: "Amount" }),
    columnHelper.accessor("order_id", {
      header: "Order ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () =>
          navigator.clipboard.writeText(cell.row.original?.order_id);
        return (
          <Tooltip title={cell.row.original?.order_id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.order_id || "N/A"}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("payment_id", {
      header: "Payment ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () =>
          navigator.clipboard.writeText(cell.row.original?.payment_id);
        return (
          <Tooltip title={cell.row.original?.payment_id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.payment_id || "N/A"}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("merchantTransactionId", {
      header: "Transaction ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () =>
          navigator.clipboard.writeText(
            cell.row.original?.merchantTransactionId,
          );
        return (
          <Tooltip title={cell.row.original?.merchantTransactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.merchantTransactionId || "N/A"}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("partnerUsername", { header: "Partner Username" }),
    columnHelper.accessor("refinery", { header: "Refinery" }),
    columnHelper.accessor("date", {
      header: "Date",
      Cell: (cell) => cell.row.original.date?.split("T")[0],
    }),
  ];

  return (
    <>
      {/* <CSVtoXLSX />   */}
      {/* */}

      {/* ✅ Date Field */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent={"flex-end"}
        gap={2}
        mb={2}
      >
        <TextField
          name="startDate"
          id="startDate"
          size="small"
          label="Select Date"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          fullWidth={isMobile}
        />
      </Box>

      {/* ✅ Table Section */}
      <Box mt={2}>
        {/* <CustomTable columns={columns} data={data} loading={loading} /> */}
        <CustomTableForDsr
          columns={columns}
          data={data}
          loading={loading}
          date={dayjs(startDate).format("DD-MM-YYYY")}
          permissionKey="Dsr"
        />
      </Box>
    </>
  );
}
